import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./SubscriptionModal.css";

import stripe from "../../../../../Assets/Images/image 6.png";
import crypto from "../../../../../Assets/Images/crypto.png";
import paypal from "../../../../../Assets/Images/PAypal.png";
// import PAypal from "../../../../../Assets/Images/PAypal.png";
// import { loadStripe } from '@stripe/stripe-js';
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import { postData } from "../../../../../Services/Api";

// Modal component
function SubscriptionModal(props) {
  const { showModal, closeModal, planDetails, userDetails } = props;

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("stripe");
  const [showPayment, setShowPayment] = useState(false);
  const [cryptoType, setCryptoType] = useState("LTCT");
  // const planDetails = props.planDetails;
  // const userDetails = props.userDetails;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${userDetails?.token}`,
  };

  const initiateStripePayment = async () => {
    try {
      const data = {
        name: planDetails.name,
        amount: planDetails.amount,
        description: planDetails.name,
        user_id: userDetails.id,
        plan_pricing_id: Number(planDetails.id),
        data_subscribed: planDetails.storage,
      };

      const response = await postData("create-payment-session", data, headers);
      window.location.href = response.data.url;
    } catch (error) {
      console.error("Error initiating Stripe payment:", error);
    }
  };

  const initiateCryptoPayment = async () => {
    try {
      // const amountInCents = Math.round(planDetails.amount * 100);
      const data = {
        amount: planDetails.amount,
        // amount: 0.5,
        currency: cryptoType,
        plan_pricing_id: Number(planDetails.id),
        data_subscribed: planDetails.storage,
      };

      const response = await postData("create-payment", data, headers, true);
      if (response?.data?.payment?.result?.txn_id) {
        setCookie("txn_id", response?.data?.payment?.result?.txn_id, 20);
      }
      if (response?.data?.payment?.result?.checkout_url)
        window.location.href = response?.data?.payment?.result?.checkout_url;
      // Open Stripe Checkout in a new tab
      // window.open(response?.data?.url, '_blank');
    } catch (error) {
      console.error("Error initiating Stripe payment:", error);
    }
  };

  function setCookie(name, value, mins) {
    var expires = "";
    if (mins) {
      var date = new Date();
      date.setTime(date.getTime() + mins * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  const handlePayNow = () => {
    if (selectedPaymentMethod === "stripe") {
      initiateStripePayment();
      setShowPayment(true);
      console.log(showPayment);
    } else if (selectedPaymentMethod === "paypal") {
      console.log("Initiating PayPal payment...");
    } else if (selectedPaymentMethod === "crypto") {
      initiateCryptoPayment();
    }
  };

  return (
    <>
      <Modal
        className=""
        show={showModal}
        onHide={closeModal}
        centered
        size="xl"
      >
        <div className="position-absolute start-0 top-0 p-5 z-n1 greenOval rounded-circle"></div>

        <div className="container-fluid shadow-lg">
          <div className="row no-gutter">
            <div className="col-md-6 rounded-end-2">
              <i
                className="text-white cursor-pointer text-end d-block m-2 fa fa-close fs-2"
                onClick={closeModal}
              />
              <div className="px-3">
                <div className="PayHead justify-content-start py-1 px-3">
                  <h3 className="text-uppercase text-black fw-bold">
                    Payment Method
                  </h3>
                </div>
                <div className="innerSubHead py-5 pb-2 px-3">
                  <div className="stripeSelectArea my-2 rounded-4 p-3">
                    <div className="d-flex justify-content-between align-items-center ps-1">
                      <div className="selectsec d-flex flex-column">
                        <div className="">
                          <div className="rdio rdio-primary radio-inline d-flex align-items-center">
                            {" "}
                            <input
                              name="radio"
                              value="1"
                              id="radioStripe"
                              type="radio"
                              checked={selectedPaymentMethod === "stripe"}
                              onChange={() =>
                                setSelectedPaymentMethod("stripe")
                              }
                              // onClick={initiateStripePayment}
                            />
                            <label htmlFor="radioStripe" className="fs-5 ms-2">
                              Stripe
                            </label>
                          </div>
                          {/* <button onClick={initiateStripePayment}></button> */}
                        </div>
                        <div className="ps-4">
                          Secure online payment through the Stripe portal
                        </div>
                      </div>
                      <div className="cf">
                        <img src={stripe} alt="Stripe" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                  <div className="stripeSelectArea my-2 rounded-4 p-3">
                    <div className="d-flex align-items-center ps-1 justify-content-between">
                      <div className="selectsec d-flex flex-column">
                        <div className="">
                          <div className="rdio rdio-primary radio-inline d-flex align-items-center">
                            {" "}
                            <input
                              name="radio"
                              value="2"
                              id="radioPaypal"
                              type="radio"
                              checked={selectedPaymentMethod === "paypal"}
                              onChange={() =>
                                setSelectedPaymentMethod("paypal")
                              }
                            />
                            <label htmlFor="radioPaypal" className="fs-5 ms-2">
                              Paypal
                            </label>
                          </div>
                        </div>
                        <div className="ps-4">
                          Secure online payment through the Paypal portal
                        </div>
                      </div>
                      <div className="cf">
                        <img src={paypal} alt="bnf" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                  <div className="stripeSelectArea my-2 rounded-4 p-3">
                    <div className="d-flex justify-content-between align-items-center ps-1">
                      <div className="selectsec d-flex flex-column">
                        <div className="">
                          <div className="rdio rdio-primary radio-inline d-flex align-items-center">
                            {" "}
                            <input
                              name="radio"
                              value="1"
                              id="radioCrypto"
                              type="radio"
                              checked={selectedPaymentMethod === "crypto"}
                              onChange={() =>
                                setSelectedPaymentMethod("crypto")
                              }
                              // onClick={initiateStripePayment}
                            />
                            <label htmlFor="radioCrypto" className="fs-5 ms-2">
                              Crypto
                            </label>
                          </div>
                        </div>
                        <div className="ps-4">
                          Secure online payment through the Crypto portal
                        </div>
                      </div>
                      <div className="cf">
                        <img src={crypto} alt="bnf" className="img-fluid" />
                      </div>
                    </div>
                    {selectedPaymentMethod === "crypto" && (
                      <div className="ps-4 mt-2">
                        <h6 syle={{ fontSize: "18px" }}>Select Network</h6>
                        <select
                          value={cryptoType}
                          onChange={(ev) => setCryptoType(ev.target.value)}
                          className="w-100 border rounded-pill border border-2 px-3 py-1 border-success form-select"
                        >
                          <option value="LTCT">LTCT</option>
                          <option value="BCH">BCH</option>
                        </select>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="m-3 mb-4 position-relative"
                  style={{ maxWidth: "min-content" }}
                >
                  {selectedPaymentMethod === "paypal" ? (
                    <>
                      <Button
                        // onClick={handlePayNow}
                        style={{ zIndex: 10, pointerEvents: "none" }}
                        className="btn btn-default text-nowrap startedBtn rounded-5 pt-2 pb-2 px-4 position-relative"
                      >
                        Pay Now
                      </Button>
                      <div
                        style={{ zIndex: 0 }}
                        className="position-absolute top-0 start-0 bottom-0 end-0 rounded-5 overflow-hidden"
                      >
                        <PayPalScriptProvider
                          options={{
                            "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
                          }}
                        >
                          <PayPalButtons
                            className="paypal-btn"
                            fundingSource={FUNDING.PAYPAL}
                            createOrder={(data, actions) => {
                              return actions.order.create({
                                purchase_units: [
                                  {
                                    amount: {
                                      value: planDetails?.amount,
                                    },
                                  },
                                ],
                                application_context: {
                                  // Disable shipping address collection
                                  shipping_preference: "NO_SHIPPING",
                                },
                              });
                            }}
                            onApprove={async (data, actions) => {
                              const details = await actions.order.capture();
                              if (details?.status === "COMPLETED") {
                                const data = {
                                  transaction_type: "Paypal",
                                  transaction_id: details.id,
                                  plan_pricing_id: planDetails.id,
                                  data_subscribed: planDetails.storage,
                                };
                                const response = await postData(
                                  "subscription-status",
                                  data,
                                  headers
                                );

                                if (response.success) {
                                  window.location.reload(true);
                                  // console.log('Subscription status updated successfully', response.data);
                                } else {
                                  console.error(
                                    "Error updating subscription status:",
                                    response.message
                                  );
                                }
                              }
                            }}
                          />
                        </PayPalScriptProvider>
                      </div>
                    </>
                  ) : (
                    <Button
                      onClick={handlePayNow}
                      className="btn btn-default startedBtn text-nowrap rounded-5 pt-2 pb-2 px-4"
                    >
                      Pay Now
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6 rounded-end-2 px-3 PaySetBg">
              <i
                onClick={props.closeModal}
                className="text-white cursor-pointer text-end curFa m-2 fa fa-close fs-2"
              />
              <div className="PayHead d-flex justify-content-center py-1">
                <h3 className="text-uppercase text-white my3">
                  Payment Settings
                </h3>
              </div>
              <div className="innerSubHead py-5 pb-4 px-3">
                <h5 className="text-white fw-medium">PRO Personal plan</h5>
                <p className="py-2 text-white"></p>
              </div>
              <div className="innerTablePay py-4 px-3">
                <div className="d-flex justify-content-between py-2">
                  <h5 className="text-white">Transaction date </h5>
                  <div className="date text-white">20/12/2023</div>
                </div>
                <div className="d-flex justify-content-between py-2 innerSubHead">
                  <h5 className="text-white">Time</h5>
                  <div className="date text-white">12:24 PM</div>
                </div>
                <div className="d-flex justify-content-between border-bottom py-3 pb-2">
                  <h5 className="text-white">Subtotal: </h5>
                  <div className="date text-white fs-6">
                    ${planDetails?.amount}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center py-3">
                  <h5 className="text-white">Total: </h5>
                  <div className="date text-white fw-medium fs-3">
                    ${planDetails?.amount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="position-absolute p-5 bottom-0 end-0 z-n1 redOval rounded-circle"></div>
      </Modal>
    </>
  );
}

export default SubscriptionModal;
